// VQ — design tokens (matched to VQ Corporate Deck Jan '26).
// Ported verbatim from vq-portal/src/theme.js so the new webui matches
// the legacy portal pixel-for-pixel.

export const T = {
  bg: "#f1f2f1",
  surface: "#ffffff",
  card: "#ffffff",
  primary: "#0067ab",
  secondary: "#009fe2",
  text: "#0d0d0d",
  muted: "#747474",
  border: "#e2e2e2",
  green: "#1a9a5a",
  red: "#c0392b",
  blue: "#009fe2",
  purple: "#6c5ce7",
  loginBg: "#0067ab",
  headerBg: "#0067ab",
};
